"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_LANGUAGE = void 0;
exports["default"] = setLanguage;
var SET_LANGUAGE = 'WEB_CHAT/SET_LANGUAGE';
exports.SET_LANGUAGE = SET_LANGUAGE;

function setLanguage(language) {
  return {
    type: SET_LANGUAGE,
    payload: {
      language: language
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfTEFOR1VBR0UiLCJzZXRMYW5ndWFnZSIsImxhbmd1YWdlIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZXRMYW5ndWFnZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfTEFOR1VBR0UgPSAnV0VCX0NIQVQvU0VUX0xBTkdVQUdFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0TGFuZ3VhZ2UobGFuZ3VhZ2UpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfTEFOR1VBR0UsXG4gICAgcGF5bG9hZDogeyBsYW5ndWFnZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9MQU5HVUFHRSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsWUFBWSxHQUFHLHVCQUFyQjs7O0FBRWUsU0FBU0MsV0FBVCxDQUFxQkMsUUFBckIsRUFBK0I7RUFDNUMsT0FBTztJQUNMQyxJQUFJLEVBQUVILFlBREQ7SUFFTEksT0FBTyxFQUFFO01BQUVGLFFBQVEsRUFBUkE7SUFBRjtFQUZKLENBQVA7QUFJRCJ9